module.exports = __webpack_public_path__ + "img/chinesecompany155.24d691e8.png";